import "./../profile.css";
import React, { useEffect } from "react";
import ReactModal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { profileAction } from "../../../redux/action";
import Loader from "react-loader-spinner";

interface IRefundDetails {
  open: boolean;
  handleClose: () => void;
  id: any;
}
const RefundDetails = ({ id, open, handleClose }: IRefundDetails) => {
  ReactModal.setAppElement("body");
  const dispatch = useDispatch();
  const refundDetails = useSelector((state: any) => state?.profile?.refundDetails || {});
  const commonLoading: any = useSelector((state: any) => (state.common.loader ? state.common.loader : false));

  useEffect(() => {
    if (id) {
      dispatch(
        profileAction.refundDetailsAction({
          RefundTrackId: id,
        })
      );
    }
  }, [id]);

  return (
    <ReactModal isOpen={open} onRequestClose={handleClose} className="my_acc_modal" overlayClassName="my_acc_overlay">
      <div className="cross_button">
        <img src="/assets/img/my-profile/cross.png" alt="" className="cursor-pointer" onClick={handleClose} />
      </div>
      <div>
        <div className="acc_modal_content">
          <h6 className="pb-3">Refund Details</h6>
          {commonLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loader type="ThreeDots" color="#fff" height={100} width={100} />
            </div>
          ) : refundDetails?.txnid ? (
            <div>
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <th>txn id</th>
                    <td>{refundDetails?.txnid}</td>
                  </tr>
                  <tr>
                    <th>Easebuzz Id</th>
                    <td>{refundDetails?.easebuzz_id}</td>
                  </tr>
                  <tr>
                    <th>Net Amount Debit</th>
                    <td>{refundDetails?.net_amount_debit}</td>
                  </tr>
                  <tr>
                    <th>Amount</th>
                    <td>{refundDetails?.amount}</td>
                  </tr>
                </tbody>
              </table>
              <table className="table table-bordered mt-3">
                <tbody>
                  <tr>
                    <th>refund_id</th>
                    <th>refund_status</th>
                    <th>merchant_refund_id</th>
                    <th>merchant_refund_date</th>
                    <th>refund_settled_date</th>
                    <th>auto_refund</th>
                    <th>refund_amount</th>
                  </tr>
                  {refundDetails?.refunds &&
                    refundDetails?.refunds?.length > 0 &&
                    refundDetails?.refunds?.map((ele: any, index: number) => (
                      <tr key={index}>
                        <td>{ele?.refund_id}</td>
                        <td>{ele?.refund_status}</td>
                        <td>{ele?.merchant_refund_id}</td>
                        <td>{ele?.merchant_refund_date}</td>
                        <td>{ele?.refund_settled_date}</td>
                        <td>{ele?.auto_refund}</td>
                        <td>{ele?.refund_amount}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center">No Data found</div>
          )}
        </div>
      </div>
    </ReactModal>
  );
};

export default RefundDetails;
